/* eslint-disable */
import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "../styles/NavBar.css";
import menu from "../assets/menu.png";
import { useTranslation } from "react-i18next";

function NavBar() {
  const location = useLocation();
  const navRef = useRef<HTMLUListElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const closeDrawer = () => setDrawerOpen(false);

  useEffect(() => {
    const activeLinkEl = navRef.current?.querySelector(
      ".nav-list li.active-link"
    );
    if (activeLinkEl) {
      const { offsetLeft, offsetWidth } = activeLinkEl as HTMLElement;
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const drawer = document.querySelector(".drawer");
      const hamburger = document.querySelector(".hamburger");
      if (
        drawerOpen &&
        drawer &&
        !drawer.contains(e.target as Node) &&
        !hamburger?.contains(e.target as Node)
      ) {
        closeDrawer();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [drawerOpen]);

  const { t } = useTranslation();

  const navItems = [
    { path: "/", label: t("nav.inicio") },
    { path: "/barco", label: t("nav.barco") },
    { path: "/abordo", label: t("nav.abordo") },
    { path: "/servicios", label: t("nav.servicios") },
    { path: "/entretenimiento", label: t("nav.entretenimiento") },
    { path: "/diversion", label: t("nav.diversion") },
    { path: "/relajacion", label: t("nav.relajacion") },
    { path: "/paquetes", label: t("nav.paquetes") },
    { path: "/contacto", label: t("nav.contacto") },
  ];
  return (
    <>
      <div
        className="hamburger"
        style={{
          position: "fixed",
          top: "1rem",
          right: "1rem",
          zIndex: 9999,
        }}
        onClick={toggleDrawer}
      >
        <img src={menu} />
      </div>
      {drawerOpen && (
        <div className="drawer-overlay" onClick={closeDrawer}></div>
      )}

      <div className={`drawer ${drawerOpen ? "open" : ""}`}>
        {navItems.map(({ path, label }) => (
          <Link
            key={path}
            to={path}
            className={location.pathname === path ? "active-link" : ""}
            onClick={() => {
              closeDrawer();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            {label}
          </Link>
        ))}
      </div>
    </>
  );
}

export default NavBar;
